export const FINANCE_NAV_SECTIONS = [
  { key: "home", path: "/main/finance/home" },
  { key: "check", path: "/main/finance/check" },
  { key: "account", path: "/main/finance/account" },
  { key: "download", path: "/main/finance/download" },
  { key: "withdraw-list", path: "/main/finance/withdraw-list" },
  { key: "send-money-list", path: "/main/finance/send-money-list" },
  { key: "balance-vip-orders", path: "/main/finance/balance-vip-orders" },
  { key: "special-share-list", path: "/main/finance/special-share-list" },
  { key: "transfer-accounts", path: "/main/finance/transfer-accounts" },
  { key: "red-packet-topups", path: "/main/finance/red-packet-topups" },
  { key: "withdraw-request-list", path: "/main/finance/withdraw-request-list" },
];

export function canViewFinanceHome(context) {
  return context.isBBLbsShop();
}

export function canViewFinanceCheck(context) {
  return context.isBBLbsShop();
}

export function canViewFinanceAccount(context) {
  return context.isBBLbsShop();
}

export function canViewFinanceDownload(context) {
  return context.isBBLbsShop();
}

export function canViewFinanceWithdrawList(context) {
  return !context.isBBLbsShop() && context.shopHasAgents();
}

export function canViewFinanceSendMoneyList(context) {
  return !context.isBBLbsShop() && context.shopHasAgents();
}

export function canViewFinanceBalanceVipOrders(context) {
  return !context.isBBLbsShop() && context.isBalanceVipEnabled();
}

export function canViewFinanceSpecialShareList(context) {
  return (
    !context.isBBLbsShop() &&
    (context.shopHasAgents() || context.isSpecialShareEnabled())
  );
}

export function canViewFinanceTransferAccounts(context) {
  return !context.isBBLbsShop() && context.isNewWechatTransferEnabled();
}

export function canViewFinanceRedPacketTopups(context) {
  return !context.isBBLbsShop() && context.isNewWechatTransferEnabled();
}

export function canViewFinanceWithdrawRequestList(context) {
  return !context.isBBLbsShop() && context.shopHasAgents();
}

const SECTION_ACCESS = {
  home: canViewFinanceHome,
  check: canViewFinanceCheck,
  account: canViewFinanceAccount,
  download: canViewFinanceDownload,
  "withdraw-list": canViewFinanceWithdrawList,
  "send-money-list": canViewFinanceSendMoneyList,
  "balance-vip-orders": canViewFinanceBalanceVipOrders,
  "special-share-list": canViewFinanceSpecialShareList,
  "transfer-accounts": canViewFinanceTransferAccounts,
  "red-packet-topups": canViewFinanceRedPacketTopups,
  "withdraw-request-list": canViewFinanceWithdrawRequestList,
};

export function getVisibleFinanceSections(context) {
  return FINANCE_NAV_SECTIONS.filter((section) => {
    const check = SECTION_ACCESS[section.key];
    return check ? check(context) : false;
  });
}

export function buildFinancePermissionContext({
  isBBLbsShop,
  shopHasAgents,
  isBalanceVipEnabled,
  isNewWechatTransferEnabled,
  isSpecialShareEnabled,
  isBdShop,
}) {
  return {
    isBBLbsShop,
    shopHasAgents,
    isBalanceVipEnabled,
    isNewWechatTransferEnabled,
    isSpecialShareEnabled,
    isBdShop,
  };
}

export function hasFinanceSubRoutePermission(pathname, context) {
  if (!pathname || pathname.indexOf("/finance/") === -1) {
    return true;
  }

  if (context.isBdShop && context.isBdShop()) {
    return false;
  }

  if (pathname.indexOf("/finance/home") !== -1) {
    return canViewFinanceHome(context);
  }
  if (
    pathname.indexOf("/finance/check") !== -1 ||
    pathname.indexOf("/finance/order-detail") !== -1
  ) {
    return canViewFinanceCheck(context);
  }
  if (pathname.indexOf("/finance/account") !== -1 || pathname.indexOf("/finance/bill-detail") !== -1) {
    return canViewFinanceAccount(context);
  }
  if (pathname.indexOf("/finance/download") !== -1) {
    return canViewFinanceDownload(context);
  }
  if (
    pathname.indexOf("/finance/withdraw-list") !== -1 ||
    pathname.indexOf("/finance/withdraw-commission-list") !== -1
  ) {
    return canViewFinanceWithdrawList(context);
  }
  if (pathname.indexOf("/finance/send-money-list") !== -1) {
    return canViewFinanceSendMoneyList(context);
  }
  if (pathname.indexOf("/finance/balance-vip-orders") !== -1) {
    return canViewFinanceBalanceVipOrders(context);
  }
  if (pathname.indexOf("/finance/special-share-list") !== -1) {
    return canViewFinanceSpecialShareList(context);
  }
  if (pathname.indexOf("/finance/transfer-accounts") !== -1) {
    return canViewFinanceTransferAccounts(context);
  }
  if (pathname.indexOf("/finance/red-packet-topups") !== -1) {
    return canViewFinanceRedPacketTopups(context);
  }
  if (pathname.indexOf("/finance/withdraw-request-list") !== -1) {
    return canViewFinanceWithdrawRequestList(context);
  }

  return true;
}
